import { generateBreadcrumbs } from '@bv/utils/route/breadcrumbs/generate-breadcrumbs';

const workflowsBreadcrumbs = generateBreadcrumbs({
  label: 'GLOBAL.NAVS.workflows_trans',
  route: { name: 'workflows' },
});

const workflows_routes = [
  {
    path: '/workflows',
    name: 'workflows',
    redirect: { name: 'workflows-list' },
    children: [
      {
        path: '',
        name: 'workflows-list',
        component: () => import('@/views/System/Workflow/WorkflowList.vue'),
        meta: {
          header: {
            title: 'GLOBAL.NAVS.workflows_trans',
            icon: 'bvi-branch',
          },
          permissions: 'read-workflows',
          breadcrumbs: workflowsBreadcrumbs(),
        },
      },
      {
        path: 'workflow-builder/:id',
        name: 'workflow-builder-detail',
        component: () => import('@/views/System/Workflow/WorkflowBuilder.vue'),
        meta: {
          permissions: 'update-workflows',
        },
      },
    ],
  },
];

export default workflows_routes;
